/** Traductions modal association code-barres (FR / AR) */
export const barcodeAutoLinkModalFr = {
  title: 'Associer le code-barres',
  scannedCode: 'Code scanné',
  foundProduct: 'Produit trouvé',
  sku: 'SKU',
  category: 'Catégorie',
  confirmMessage: 'Voulez-vous associer ce code-barres à ce produit ? Cette association sera sauvegardée et reconnue automatiquement lors des prochains scans.',
  cancel: 'Annuler',
  saving: 'Sauvegarde…',
  link: 'Associer',
  closeAria: 'Fermer'
};

export const barcodeAutoLinkModalAr = {
  title: 'ربط الرمز الشريطي',
  scannedCode: 'الرمز الممسوح',
  foundProduct: 'المنتج المطابق',
  sku: 'SKU',
  category: 'الفئة',
  confirmMessage: 'هل تريد ربط هذا الرمز الشريطي بهذا المنتج؟ سيتم حفظ الربط والتعرف عليه تلقائياً في المسحات القادمة.',
  cancel: 'إلغاء',
  saving: 'جاري الحفظ…',
  link: 'ربط',
  closeAria: 'إغلاق'
};
